const getters = {
  getDocument: (state) => state.document,
  getCampaigns: (state) => state.campaigns,
  getCampaignsMeta: (state) => state.campaignsMeta,
  getCampaignContacts: (state) => state.campaignContacts,
  getCampaignContactsMeta: (state) => state.campaignContactsMeta,
  getTemplates: (state) => state.templates,
  getReports: (state) => state.reports,
  getReportsMeta: (state) => state.reportsMeta,
};

export default getters;
